<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0 overflow-y-auto">

  <!-- STICKY HEADER -->
  <div class="sticky -top-2 z-20 bg-zinc-100 dark:bg-zinc-900 py-2">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

      <!-- LEFT: SEARCH + STATUS -->
    <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
      <div class="relative">
        <input type="text" [(ngModel)]="search" (input)="onSearchInput()" placeholder="Search.." class="pl-8" />
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </div>
      <!-- <div>
        <select (change)="onSelectStatus()" [(ngModel)]="selectedStatus" id="inputStatus" class="min-w-40">
          <option [ngValue]="true">Active</option>
          <option [ngValue]="false">Inactive</option>
        </select>
      </div> -->
      <div>
        <select [(ngModel)]="type" (change)="onSelectType()" id="inputType" class="min-w-40">
          <option value="video">Video</option>
          <option value="document">Document</option>
        </select>
      </div>
    </div>

      <!-- ENTRIES COUNT -->
      <div *ngIf="filtertutorialsList && filtertutorialsList.length">
        <h1 class="text-xs text-nowrap text-left text-zinc-500 dark:text-zinc-400">
          Showing {{(numberOfRecords * currentPage) - (filtertutorialsList.length != numberOfRecords ? (numberOfRecords - filtertutorialsList.length) : 0) }} of {{totalResults}} entries
        </h1>
      </div>

      <!-- RIGHT: ADD BUTTON -->
      <!-- <button *ngIf="permissionService.hasPermission([userPermission.MANAGE_ACADEMY])" class="btn btn-primary whitespace-nowrap" routerLink="add">
        + Add Tutorial
      </button> -->

    </div>

  </div>

  <!-- GRID -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
    <!-- CARD -->
    <div
      *ngFor="let tutorial of filtertutorialsList | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems: totalResults }"
      class="group bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-800 rounded-2xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-2 transition-all duration-500 flex flex-col">
  
      <!-- IMAGE -->
      <div class="relative aspect-3/2 overflow-hidden bg-zinc-100 dark:bg-zinc-900">
  
              <img [src]="(tutorial.type === 'document' && !tutorial.thumbnailURL) ? 'assets/images/document-placeholder.png' : tutorial.thumbnailURL"
                class="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
  
        <div class="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition duration-500"></div>
  
        <a [href]="tutorial.videoURL" target="_blank" rel="noopener noreferrer" class="absolute inset-0 flex items-center justify-center">
  
          <div class="w-14 h-14 rounded-full bg-white shadow-xl flex items-center justify-center
          opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition duration-500">
            <svg *ngIf="type === 'video'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
              class="w-6 h-6 text-primary ml-1">
              <path d="M8 5.14v13.72c0 .77.83 1.25 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z" />
            </svg>
            <svg *ngIf="type === 'document'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5" class="w-6 h-6 text-primary">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
          </div>
        </a>

        <!-- COPY LINK -->
        <button type="button" [appCopyToClipboard]="tutorial.videoURL" copyLabel="link" copyTooltip="Copy link"
          class="absolute top-2 right-2 z-10 w-8 h-8 rounded-full bg-white shadow flex items-center justify-center
          opacity-0 group-hover:opacity-100 transition duration-300 hover:scale-110">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" class="w-4 h-4 text-primary">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
          </svg>
        </button>
      </div>

      <!-- CONTENT -->
      <div class="p-4 flex flex-col flex-1">
  
        <!-- TITLE -->
        <h2 class="heading line-clamp-1 group-hover:text-primary transition">
          {{tutorial.name}}
        </h2>
  
        <!-- DESCRIPTION -->
        <p class="text-xs-light line-clamp-2 mt-1 text-zinc-500">
          {{tutorial.description}}
        </p>
      </div>
  
    </div>
  </div>

  <!-- PAGINATION CONTROLS -->
  <div class="mt-4 flex justify-end" *ngIf="totalResults > numberOfRecords">
    <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
  </div>

</section>